<p *ngIf="changeLogTags.length" class="text-center mt-0">
    {{ tagsTitle | translate }}
</p>

<div class="change-log-tags">
    <div *ngFor="let tag of changeLogTags" class="change-log-tag">{{ tag }}</div>
</div>
